import { render, staticRenderFns } from "./FolderAddForm.vue?vue&type=template&id=6d897bfc"
import script from "./FolderAddForm.vue?vue&type=script&lang=js"
export * from "./FolderAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports